import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CompteurCredits, useCredits } from '../credits/CreditBadge';
import { useAcces, moduleVisible } from '../../hooks/useAcces';
import { MODULES_360 } from '../accueil/Sidebar360';

/* Le rôle d'accès (GET /acces/moi, vérifié côté serveur) décide ce qu'on voit : Équipier → /moi, Chef → /moi + ses modules, Associé → Accueil en lecture seule.
   Une page d'un module hors du rôle renvoie vers l'écran d'ouverture du rôle. + compteur Crédits en haut à droite (tap = écran Crédits), alerte à 10. */
const LIBRES = ['/moi', '/tablette', '/mon-compte', '/login', '/aide', '/acces', '/mon-parcours'];  // LOT 51 · 1.3 · l'équipier fait sa formation
export const AccesParRole = ({ slug, pathname }) => {
  const navigate = useNavigate();
  const credits = useCredits();
  const acces = useAcces();
  useEffect(() => {
    if (!acces.loaded || !slug || acces.role === 'direction') return;
    const rel = pathname.replace(`/${slug}`, '') || '/dashboard';
    if (LIBRES.some((p) => rel === p || rel.startsWith(`${p}/`) || rel.startsWith(`${p}?`))) return;
    const ouverture = acces.ouvre_sur === 'moi' ? `/${slug}/moi` : acces.ouvre_sur === 'finance' ? `/${slug}/finance` : `/${slug}/dashboard`;
    if (acces.role === 'equipier') { navigate(ouverture, { replace: true }); return; }
    const mod = MODULES_360.find((m) => m.match.some((p) => rel === p || rel.startsWith(`${p}/`) || rel.startsWith(`${p}?`)));
    if (!mod && acces.ouvre_sur === 'moi') { navigate(ouverture, { replace: true }); return; }
    if (acces.role === 'controle_gestion' && rel.startsWith('/dashboard')) { navigate(ouverture, { replace: true }); return; }
    if (mod && !moduleVisible(acces, mod.key)) navigate(ouverture, { replace: true });
  }, [acces, pathname, slug, navigate]);
  if (!acces.loaded || acces.ouvre_sur === 'moi' || !credits.loaded || pathname.endsWith('/dashboard')) return null;
  return <div className="crd-compteur-global hidden md:flex" data-testid="credits-compteur-global"><CompteurCredits credits={credits} testId="credits-compteur-global-btn" />{credits.alerte && <span className="crd-alerte" data-testid="credits-alerte">il vous reste {credits.balance} crédits · rechargez avant la fin du mois</span>}</div>;
};
